export function toRem(value: number): string {
  return `${value / 16}rem`;
}
